import { render, staticRenderFns } from "./DCAddDetails.vue?vue&type=template&id=6f200102&scoped=true&"
import script from "./DCAddDetails.vue?vue&type=script&lang=js&"
export * from "./DCAddDetails.vue?vue&type=script&lang=js&"
import style0 from "./DCAddDetails.vue?vue&type=style&index=0&id=6f200102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f200102",
  null
  
)

export default component.exports